import { IAccountIsFiredLang } from '../../../types/lang'
import { EAccountIsFired } from '../../../types'

export const accountIsFiredLang: IAccountIsFiredLang = {
	account_is_fired: {
		[EAccountIsFired.Fired]: 'Fired_ua',
		[EAccountIsFired.NotFired]: 'Not Fired_ua',
	}
}